import { render, staticRenderFns } from "./RegistroExci.vue?vue&type=template&id=bff6dad4"
import script from "./RegistroExci.vue?vue&type=script&lang=js"
export * from "./RegistroExci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports